import React from 'react';

import { MemberChallenge } from '@wix/ambassador-challenges-v1-challenge/types';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { isChallengePaidWithoutParticipation } from './isChallengePaidWithoutparticipation';
import { isUserJoinedAlready } from '../../../../contexts/User/helpers/userTypeHandlers';
import { FCWithChildren } from '@wix/challenges-web-library';
import { getParticipantStateFromSummary } from '../../../ChallengesList/Badge/helpers/GetParticipantStateFromSummary';
import { useChallengesList } from '../../../../contexts/storage-contexts/ChallengesList';
import { useMemberPaidPlans } from '../../../../contexts/storage-contexts/PaidPlans';
import { classes } from './ChallengeItem.st.css';

export interface IGoToChallenge {
  challenge: MemberChallenge;
}

function getProgramTitle(memberProgram: MemberChallenge) {
  return memberProgram?.challenge?.settings?.description?.title || '';
}

export const GoToChallenge: FCWithChildren<IGoToChallenge> = ({
  challenge,
}) => {
  const { t } = useTranslation();
  const ppCtx = useMemberPaidPlans();
  const listCtx = useChallengesList();
  const { isPreview } = useEnvironment();
  const link = listCtx.getProgramLink(challenge.challenge);

  const isJoined = React.useMemo(() => {
    return isUserJoinedAlready(
      getParticipantStateFromSummary(challenge.summary),
    );
  }, [challenge]);

  let title = '';

  if (isJoined) {
    title = t('members-area.cta.go-to-challenge');
  } else if (
    isChallengePaidWithoutParticipation(challenge, ppCtx.userPaidPlans)
  ) {
    title = t('members-area.cta.complete-payment');
  } else {
    title = t('members-area.cta.view-challenge');
  }

  return (
    <a
      data-hook="go-to-program-link"
      data-program-id={challenge?.challenge?.id}
      aria-label={`${title}: "${getProgramTitle(challenge)}"`}
      className={classes.link}
      href={link}
      onClick={(e) => {
        // breaks preview navigation
        // https://wix.slack.com/archives/CQF1SC6MN/p1724799078457399
        if (!isPreview) {
          location.href = link;

          e.stopPropagation();
          e.preventDefault();
        }
      }}
    >
      {title}
    </a>
  );
};
